/* istanbul ignore file */
import { useFileUploadManager } from '@/helpers/misc/file-upload';
import useIsolatedDialog from './useIsolatedDialog';

/**
 * This function returns the controls related to dialog.
 * @param {object} params This object contain four parameter.
 * @param {function} params.beforeOpen - This function related to actions to be performed before opening dialog.
 * @param {function} params.onCancel - This function related to actions to be taken when closing the dialog.
 * @param {function} params.onClear - This function related to clearing data when closing dialog.
 * @param {array} params.model - This array containing image objects.
 * @returns {object} object - Return useFileUpload and useIsolatedDialog functions returns.
 * @example{
 *    const {fileUpload, dialog} = useFileUploadWithDialog (beforeOpen, onCancel, onClear, model);
 *
 *    return{
 *      fileUpload: useFileUpload fn return values. See function page for details.
 *      dialog: useIsolatedDialog fn returns values. See function page for details.
 *    }
 * }
 */
const useFileUploadWithDialog = ({
  multiple,
  extensions,
  validateFile,
  transform,
  beforeOpen,
  onCancel,
  onClear,
  onCompleted,
  model,
  fileNameSuffix,
}) => {
  const dialog = useIsolatedDialog({
    beforeOpen, onCancel, onClear, model,
  });

  const fileUploadManager = useFileUploadManager({
    multiple,
    extensions,
    validateFile,
    transform,
    onCompleted,
    model,
    fileNameSuffix,
  });

  return {
    dialog,
    ...fileUploadManager,
  };
};

export default useFileUploadWithDialog;
